import { ELEMENTS_VARIABLES } from 'constants/index';
import { getName } from 'utils/string';

/**
 * Updates variable's value based on changes to specific draft fields.
 *
 * @param {string} whatChangedkey - The key path of the changed field in the draft (e.g., 'draft.header.rawtitle', 'draft.signature.rawmyname')
 * @param {Object} newDraft - The updated draft object containing the changes
 * @returns {Object} The updated draft object with synchronized variables
 */
export const updateVariables = (whatChangedkey, newDraft) => {
  /*
  if header title changed update the variables value
  draft.header.rawtitle

  if siganture changed update the variables value
  draft.signature.rawmyname
  draft.signature.rawname
  draft.signature.additionalSignature.rawname
  */
  let variableKey = null;
  let draftBlocks = null;
  let text = null;

  if (whatChangedkey === 'draft.header.rawtitle') {
    draftBlocks = newDraft.header.rawtitle.blocks;
    variableKey = 'proposal';
  } else if (whatChangedkey === 'draft.signature.rawmyname') {
    draftBlocks = newDraft.signature.rawmyname.blocks;
    variableKey = 'sender';
  } else if (whatChangedkey === 'draft.signature.rawname') {
    draftBlocks = newDraft.signature.rawname.blocks;
    variableKey = 'client';
  } else if (whatChangedkey === 'draft.signature.additionalSignature.rawname') {
    draftBlocks = newDraft.signature.additionalSignature.rawname.blocks;
    variableKey = 'client2';
  } else if (whatChangedkey === 'draft.signature.additionalSignature') {
    draftBlocks = [''];
    variableKey = 'client2';
    text = newDraft.signature.additionalSignature.name;
  }

  if (!draftBlocks?.length) {
    return newDraft;
  }

  if (!text) {
    text = draftBlocks.map((block) => block.text).join(' ');
  }
  if (text.includes('{')) {
    return newDraft;
  }

  const variables = { ...newDraft?.variables };
  if (!variables[variableKey]) {
    variables[variableKey] = { ...ELEMENTS_VARIABLES()[variableKey] };
  }

  const variableData = variables[variableKey];
  if (variableKey === 'proposal') {
    variableData.name.value = text;
    variableData.title.value = text;
  } else {
    const { firstName, lastName } = getName(text);
    variableData.lastName.value = lastName;
    variableData.firstName.value = firstName;
    variableData.fullName.value = `${firstName} ${lastName}`;

    // reset all when additional signature is added
    if (whatChangedkey === 'draft.signature.additionalSignature') {
      variableData.email.value = '';
      variableData.phone.value = '';
    }
  }
  newDraft.variables[variableKey] = variableData;

  return newDraft;
};
